import React, { useEffect, useState } from 'react'
import LightText, { LighterBig, LighterBold, LighteroneBig, smallestText, smallText } from '../../Assets/CSS/Text'
import axios from 'axios';
import toast from 'react-hot-toast';
import '../../Assets/CSS/Department.css'

const Role = () => {
    const [formData, setFormData] = useState({
        userRole: '',
    });
    const [historyData, setHistoryData] = useState([]);
    const [loading, setLoading] = useState(false);

    const createRole = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");

            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/roles`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200 || response.status === 201) {
                toast.success("Role created successfully!");
                setFormData({ userRole: "" });
            } else {
                toast.error("Failed to create role. Try again.");
            }
        } catch (error) {
            console.error("Error creating role:", error);
            toast.error(error.response?.data?.message || "Server error occurred");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        const fetchHistory = async () => {
            try {
                setLoading(true);
                const token = localStorage.getItem("token"); // if auth is required
                const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/roles?page=0&size=10`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                // Assuming API returns something like: { content: [ { roleName, createdBy, createdOn } ] }
                setHistoryData(res.data.content || []);
            } catch (error) {
                console.error("Error fetching role history:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchHistory();
    }, []);

    return (
        <div className="container px-4">
            <div className="border-bottom pb-3">
                <h6 style={LighterBig}>Create New Role</h6>

                <div className="row mt-3">
                    <div className="col-12 col-md-6 col-lg-4 d-flex flex-column gap-2">
                        <h6 style={LightText}>Role</h6>

                        <input
                            type="text"
                            className="form-control ps-3 rounded-4"
                            placeholder="Enter Role name"
                            value={formData.userRole}
                            onChange={(e) =>
                                setFormData({ ...formData, userRole: e.target.value })
                            }
                        />

                        <button
                            className="add-button mt-2"
                            onClick={createRole}
                            disabled={loading || !formData.userRole.trim()}
                        >
                            {loading ? "Creating..." : "Create Role"}
                        </button>
                    </div>
                </div>
            </div>

            {/* History Section */}
            <div className="mt-4 pt-4">
                <h6 className="fw-semibold mb-4">History</h6>

                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status"></div>
                    </div>
                ) : (
                    <div className="timeline-container position-relative ps-3">
                        {/* Vertical Line */}
                        <div
                            className="position-absolute top-0 bottom-0"
                            style={{
                                width: "2px",
                                backgroundColor: "#E0E0E0",
                                left: "4px",
                            }}
                        ></div>

                        {historyData.length > 0 ? (
                            historyData.map((item, index) => (
                                <div
                                    key={index}
                                    className="timeline-item d-flex flex-wrap align-items-start gap-2 mb-3 position-relative "
                                >
                                    {/* Dot */}
                                    <div
                                        className="position-absolute rounded-circle"
                                        style={{
                                            width: "10px",
                                            height: "10px",
                                            backgroundColor: "#A1A1A1",
                                            left: "-16px",
                                            top: "8px",
                                        }}
                                    ></div>
                                    {/* <div className='d-flex justify-content-between align-items-center' style={{ gap: '6.25rem' }}> */}
                                    <div className='role-row d-flex justify-content-between align-items-center flex-wrap'>

                                        {/* Role Name */}
                                        <h6
                                            className="mb-0"
                                            style={{ ...LighterBold, minWidth: "250px" }}
                                        >
                                            {item.userRole || "N/A"}
                                        </h6>

                                        {/* Created By */}
                                        <div>
                                            {/* <h6 className="fw-semibold mb-0" style={smallText}>
                                                {item.createdBy || "Admin"}
                                            </h6> */}
                                            <h6 className="fw-semibold mb-0" style={smallText}>
                                                {item.createdBy
                                                    ?.split("Admin")[0]            // remove "Admin (RAK-101)"
                                                    .trim()                        // clean spaces
                                                    .replace(/\b\w/g, char => char.toUpperCase()) || "N/A"}
                                            </h6>


                                            <small style={smallestText}>Created by</small>
                                        </div>

                                        {/* Created On */}
                                        <div>
                                            <h6 className="fw-semibold mb-0" style={smallText}>
                                                {item.createdDate
                                                    ? new Date(item.createdDate).toLocaleDateString("en-GB", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                    })
                                                    : "—"}
                                            </h6>
                                            <small style={smallestText}>Created on</small>
                                        </div>
                                    </div>



                                </div>
                            ))
                        ) : (
                            <p className="text-muted ps-4">No records found.</p>
                        )}
                    </div>
                )}
            </div>
        </div>
    );

}

export default Role